<template>
  <div class="accessory-cost tb">
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
    ></custom-tab>
    <costs v-if="tabIndex === 0"></costs>
    <share v-if="tabIndex === 1"></share>
  </div>
</template>

<script>
import costs from './children/costs.vue';
import share from './children/share.vue';

export default {
  name: 'accessoryCost',
  mixins: [],
  components: {
    costs,
    share
  },
  props: {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('crm_accessoryCost.pei_jian_cheng_ben'),
          value: 0,
        },
        {
          name: this.$t('crm_accessoryCost.fen_tan_hui_zong'),
          value: 1,
        },
      ];
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {

  },
  created() {},
  mounted() {
    this.getFuncView();

  },
};
</script>

<style lang="scss" scoped>
.accessory-cost {
  padding-left: 0 !important;


}
</style>
